import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React from "react";

// Start Bugsnag with the React plugin
Bugsnag.start({
  apiKey: "b77158276cfadfabb94d8576ff93d249", // Replace with your actual API key
  plugins: [new BugsnagPluginReact(React)], // Pass React to the plugin constructor
});

// Create the ErrorBoundary using the Bugsnag React plugin
const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary();

export default ErrorBoundary;
